import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function deleteTripFolderDocument(id: number, documentId: number) {
  return restApiClient
    .url(constructApiUrl(API.tripFolder.deleteDocument.url, { id, documentId }))
    .delete()
}
